export const products = [
  {
    id: 1,
    name: "Máscara Facial Roxo Ametista",
    subtitle: "Efeito Lifting & Glow",
    description: "Máscara facial com efeito tensor e iluminador, que ajuda a revitalizar a pele, promovendo firmeza, luminosidade e aspecto rejuvenescido.",
    category: "Skin Care",
    price: 89.90,
    originalPrice: 119.90,
    rating: 4.9,
    reviews: 247,
    badge: "Mais Vendido",
    image: "https://storage.readdy-site.link/project_files/bc073682-be8a-41b0-bc42-811cad36305d/4eb0e06c-e298-4eaa-91a3-f38270d8353c_Screen-Shot-2026-03-21-at-4.03.52-PM.png?v=121ed07640a8f39470b4337f16b3a40e",
  },
  {
    id: 2,
    name: "Iluminador Hidratante Corporal Bronze",
    subtitle: "\"Samba\" – Brilho & Hidratação",
    description: "Hidratante corporal com efeito iluminador bronzeado, que realça o brilho da pele e proporciona hidratação com toque sensual e festivo.",
    category: "Body Care",
    price: 74.90,
    originalPrice: 99.90,
    rating: 4.8,
    reviews: 189,
    badge: "Novo",
    image: "https://public.readdy.ai/ai/img_res/a3aff1c1-f904-46ae-a5eb-0e394ff0c18e.png",
  },
  {
    id: 3,
    name: "Sabonete Íntimo Feminino",
    subtitle: "Xerolayne Íntimos",
    description: "Produto de cuidado íntimo com ação delicada, auxiliando na limpeza diária sem agredir a flora natural, promovendo conforto e confiança.",
    category: "Higiene Íntima",
    price: 49.90,
    originalPrice: 69.90,
    rating: 4.7,
    reviews: 312,
    badge: null,
    image: "https://public.readdy.ai/ai/img_res/3f99ab06-f47d-4213-916d-3d79ccb2167f.png",
  },
  {
    id: 4,
    name: "Sabonete Íntimo Feminino",
    subtitle: "Frescor da Xana",
    description: "Fórmula suave com fragrância leve e refrescante, ideal para manter a higiene íntima com conforto, segurança e sensação prolongada de frescor.",
    category: "Higiene Íntima",
    price: 49.90,
    originalPrice: 69.90,
    rating: 4.9,
    reviews: 156,
    badge: "Exclusivo",
    image: "https://public.readdy.ai/ai/img_res/a9a3851d-9ab4-443b-8cfd-dd75739edfbd.png",
  },
  {
    id: 5,
    name: "Sabonete Íntimo Feminino",
    subtitle: "Xibiu Cheiroso",
    description: "Sabonete íntimo com pH equilibrado para uso diário, desenvolvido para proporcionar frescor, proteção e cuidado na região íntima feminina.",
    category: "Higiene Íntima",
    price: 49.90,
    originalPrice: 69.90,
    rating: 4.6,
    reviews: 203,
    badge: null,
    image: "https://public.readdy.ai/ai/img_res/1183073a-bb12-4b7a-bb96-98a7fb3a4c4a.png",
  },
  {
    id: 6,
    name: "Aromatizador de Ambiente",
    subtitle: "Limão Siciliano & Folhas de Limoeiro",
    description: "Aromatizador natural com fragrância cítrica refrescante, que promove sensação de limpeza, leveza e bem-estar no ambiente. Ideal para uso residencial ou comercial.",
    category: "Home Care",
    price: 59.90,
    originalPrice: 79.90,
    rating: 4.8,
    reviews: 278,
    badge: "Limitado",
    image: "https://public.readdy.ai/ai/img_res/368a6c67-0ef0-4689-bdbe-26758bdf0d77.png",
  },
  {
    id: 7,
    name: "Sabonete Líquido Leite de Cabra",
    subtitle: "Nutrição & Maciez Profunda",
    description: "Sabonete líquido hidratante enriquecido com leite de cabra, que nutre profundamente a pele, proporcionando maciez, suavidade e limpeza delicada.",
    category: "Body Care",
    price: 44.90,
    originalPrice: 59.90,
    rating: 4.9,
    reviews: 134,
    badge: "Novo",
    image: "https://storage.readdy-site.link/project_files/bc073682-be8a-41b0-bc42-811cad36305d/3453797c-3210-4a12-84dc-ab37c3483a36_Screen-Shot-2026-03-21-at-4.04.20-PM.png?v=f1fd803c9aedb82ec1b9dcf9c2f5afcd",
  },
];